
import SupplierBrands from '../../views/supplierbrands/SupplierBrands.vue'
import SupplierBrand from '../../views/supplierbrands/SupplierBrand.vue'
import SupplierBrandGeneral from '../../views/supplierbrands/SupplierBrandGeneral.vue'
import SupplierBrandProjects from '../../views/supplierbrands/SupplierBrandProjects.vue'
import SupplierBrandProjectAllPeriods from '../../views/supplierbrands/SupplierBrandProjectAllPeriods.vue'
import SupplierBrandProject from '../../views/supplierbrands/SupplierBrandProject.vue'
import SupplierBrandFlowSummary from '../../views/supplierbrands/SupplierBrandFlowSummary.vue'
import SupplierBrandFlowNonconformity from '../../views/supplierbrands/SupplierBrandFlowNonconformity.vue'
import SupplierCards from '../../views/supplierbrands/SupplierCards.vue'
import Suppliercard from '../../views/supplierbrands/Suppliercard.vue'


import {roleSystemRoute} from './route_utilities'

export const supplierbrands = {
	path: 'supplierbrands',
	name: 'SupplierBrands',
	component: SupplierBrands,
	meta: {
		title: "tedarikci_markalari",
		domain:"supplierbrands"
	},
}

export const supplierbrand = {
      path: 'supplierbrand/:supplier_uuid',
      name: 'SupplierBrand',
      component: SupplierBrand,
      redirect: { name: 'SupplierBrandGeneral' },
      meta: {
          title: "marka",
          preloader:true,
          domain:"supplierbrands"
        },
        children:[
        {
          path: 'brand',  
          name: 'SupplierBrandGeneral',
          component: SupplierBrandGeneral,
          meta: {
              title: "marka",
              preloader:true,
              domain:"supplierbrands"
            },
         },
         {
          path: 'supplier_cards',  
          name: 'SupplierCards',
          component: SupplierCards,
          meta: {
              title: "tedarikci_kartlari",
              preloader:true,
              domain:"supplierbrands"
            },
         },
         {
          path: 'projects',  
          name: 'SupplierBrandProjects',
          component: SupplierBrandProjects,
          meta: {
              title: "marka_projeleri",
              preloader:true,
              domain:"supplierbrands"
            },
         },
         {
          path: 'project_all_periods/:project_id',  
          name: 'SupplierBrandProjectAllPeriods',
          component: SupplierBrandProjectAllPeriods,
          meta: {
              title: "projeler",
              preloader:true,
              domain:"supplierbrands"
            },
         },
         {
          path: 'project/:project_id',  
          name: 'SupplierBrandProject',
          component: SupplierBrandProject,
          meta: {
              title: "marka_projesi",
              preloader:true,
              domain:"supplierbrands"
            },
         },
         {
          path: 'supplier_card/:card_id',  
          name: 'Suppliercard',
          component: Suppliercard,
          meta: {
              title: "tedarikci_karti",
              preloader:true,
              domain:"supplierbrands"
            },
         },
         {
          path: 'project/:project_id/flow_summary/:flow_id',  
          name: 'SupplierBrandFlowSummary',
          component: SupplierBrandFlowSummary,
          meta: {
              title: "marka_projesi",
              preloader:true,
              domain:"supplierbrands"
            },            
         },
         {
          path: 'nonconformity/:nonconformity_id',  
          name: 'SupplierBrandFlowNonconformity',
          component: SupplierBrandFlowNonconformity,
          meta: {
              title: "uygunsuzluk",
              preloader:true,
              domain:"supplierbrands"
            },
         },

        ]
      }


 